import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { StatusBadge } from "@/components/StatusBadge";
import { DeadlineBadge } from "@/components/DeadlineBadge";

export default function ClientHistory() {
  const nav = useNavigate();
  const [orders, setOrders] = useState([]);
  useEffect(() => {
    api.get("/orders").then(({ data }) => setOrders(data));
  }, []);

  return (
    <div className="mx-auto max-w-6xl space-y-6">
      <div>
        <h2 className="font-display text-2xl font-bold tracking-tight text-slate-900">Service history</h2>
        <p className="text-slate-500">Full record of every service order you've placed.</p>
      </div>
      <div className="overflow-hidden rounded-xl border border-slate-200 bg-white">
        <table className="w-full text-sm">
          <thead className="border-b border-slate-100 bg-slate-50 text-left text-xs uppercase tracking-wide text-slate-500">
            <tr>
              <th className="px-5 py-3">Job #</th><th className="px-5 py-3">Defendant</th>
              <th className="px-5 py-3">Type</th><th className="px-5 py-3">Attempts</th><th className="px-5 py-3">Deadline</th><th className="px-5 py-3">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {orders.map((o) => (
              <tr key={o.id} data-testid={`history-row-${o.job_number}`} onClick={() => nav(`/client/orders/${o.id}`)} className="cursor-pointer transition hover:bg-slate-50">
                <td className="px-5 py-3 font-mono-arps font-semibold text-slate-900">#{o.job_number}</td>
                <td className="px-5 py-3 text-slate-700">{o.defendant}</td>
                <td className="px-5 py-3 text-slate-500">{o.service_type}</td>
                <td className="px-5 py-3 text-slate-500">{o.attempts_count ?? 0}</td>
                <td className="px-5 py-3"><DeadlineBadge status={o.deadline_status} days={o.days_to_deadline} /></td>
                <td className="px-5 py-3"><StatusBadge status={o.status} /></td>
              </tr>
            ))}
            {orders.length === 0 && <tr><td colSpan={6} className="px-5 py-12 text-center text-slate-400">No history yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
